<template>
  <main class="login-page">
    <div class="login-orb login-orb-one"></div>
    <div class="login-orb login-orb-two"></div>

    <section class="login-shell">
      <div class="login-brand-panel">
        <div>
          <div class="brand-mark">
            <span class="brand-mark-left"></span>
            <span class="brand-mark-right"></span>
          </div>
          <p class="brand-eyebrow">LINGYOU WORKSPACE</p>
          <h1>把复杂的业务，<br />变成清晰的增长。</h1>
          <p class="brand-description">
            统一管理运营、采购、库存与广告数据，所有业务请求由安全网关集中鉴权。
          </p>
        </div>

        <div class="brand-security">
          <span class="security-icon">
            <i class="el-icon-lock"></i>
          </span>
          <div>
            <strong>企业级安全访问</strong>
            <p>统一身份认证 · 接口级权限控制</p>
          </div>
        </div>
      </div>

      <div class="login-form-panel">
        <div class="mobile-brand">
          <div class="brand-mark small">
            <span class="brand-mark-left"></span>
            <span class="brand-mark-right"></span>
          </div>
          <span>灵柚管理系统</span>
        </div>

        <div class="login-form-wrap">
          <p class="welcome-label">WELCOME BACK</p>
          <h2>欢迎登录</h2>
          <p class="login-tip">请输入您的账户信息，进入灵柚业务工作台</p>

          <el-form ref="loginForm" :model="form" :rules="rules" @submit.native.prevent="login">
            <el-form-item prop="username">
              <label class="field-label">账号</label>
              <el-input
                v-model.trim="form.username"
                placeholder="请输入登录账号"
                prefix-icon="el-icon-user"
                autocomplete="username"
                @keyup.enter.native="focusPassword"
              ></el-input>
            </el-form-item>

            <el-form-item prop="password">
              <label class="field-label">密码</label>
              <el-input
                ref="passwordInput"
                v-model="form.password"
                placeholder="请输入登录密码"
                prefix-icon="el-icon-lock"
                type="password"
                autocomplete="current-password"
                show-password
                @keyup.enter.native="login"
              ></el-input>
            </el-form-item>

            <div class="form-meta">
              <el-checkbox v-model="rememberAccount">记住账号</el-checkbox>
              <span class="secure-entry"><i class="el-icon-circle-check"></i> 安全登录</span>
            </div>

            <el-button class="login-submit" type="primary" native-type="submit" :loading="submitting">
              {{ submitting ? "正在验证..." : "登录工作台" }}
              <i v-if="!submitting" class="el-icon-right"></i>
            </el-button>
          </el-form>

          <p class="login-footer">© {{ currentYear }} 灵柚管理系统 · 让经营更简单</p>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { setAuthToken } from "@/utils/auth";
import { mountDynamicRoutes } from "@/router";
import { resolveLoginTarget } from "./loginRedirect";

const ACCOUNT_KEY = "ds_gateway_remembered_account";

export default {
  name: "LoginPage",
  data() {
    return {
      form: {
        username: localStorage.getItem(ACCOUNT_KEY) || "",
        password: "",
      },
      rememberAccount: Boolean(localStorage.getItem(ACCOUNT_KEY)),
      submitting: false,
      currentYear: new Date().getFullYear(),
      rules: {
        username: [{ required: true, message: "请输入登录账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入登录密码", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.form.username) {
        this.focusPassword();
      }
    });
  },
  methods: {
    focusPassword() {
      const input = this.$refs.passwordInput;
      if (input) {
        input.focus();
      }
    },
    login() {
      if (this.submitting) {
        return;
      }
      this.$refs.loginForm.validate(valid => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$store.dispatch("user/login", this.form)
          .then(async () => {
            setAuthToken(this.$store.state.user.token);
            // 挂载动态路由,再跳转,保证目标路由已经存在
            mountDynamicRoutes();
            if (this.rememberAccount) {
              localStorage.setItem(ACCOUNT_KEY, this.form.username);
            } else {
              localStorage.removeItem(ACCOUNT_KEY);
            }
            this.$message.success("登录成功，欢迎回来");
            const target = resolveLoginTarget(
              this.$route.query.redirect,
              this.$store.state.user.menuTree,
            );
            this.$router.replace(target);
          })
          .catch(err => {
            this.$message.error(err.message || "账号或密码错误，请重新输入");
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-page {
  --navy: #13283d;
  --navy-deep: #0b1d2d;
  --mint: #42bc91;
  --mint-dark: #25a478;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  box-sizing: border-box;
  background:
    radial-gradient(circle at 7% 10%, rgba(66, 188, 145, 0.13), transparent 28%),
    linear-gradient(145deg, #eef7f4 0%, #f7fafc 48%, #eaf1f5 100%);
  font-family: "PingFang SC", "Microsoft YaHei", Inter, sans-serif;
}

.login-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(2px);
  pointer-events: none;
}

.login-orb-one {
  width: 340px;
  height: 340px;
  right: -120px;
  top: -110px;
  background: rgba(66, 188, 145, 0.12);
}

.login-orb-two {
  width: 280px;
  height: 280px;
  left: -100px;
  bottom: -130px;
  border: 55px solid rgba(19, 40, 61, 0.06);
}

.login-shell {
  width: min(1080px, 100%);
  min-height: 650px;
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1.02fr 0.98fr;
  overflow: hidden;
  border-radius: 28px;
  background: #fff;
  box-shadow: 0 30px 80px rgba(20, 45, 63, 0.18);
}

.login-brand-panel {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 70px 68px 58px;
  color: #fff;
  background:
    linear-gradient(160deg, rgba(255, 255, 255, 0.035) 0 1px, transparent 1px 42px),
    linear-gradient(70deg, rgba(255, 255, 255, 0.035) 0 1px, transparent 1px 42px),
    linear-gradient(150deg, var(--navy) 0%, var(--navy-deep) 100%);
  background-size: 42px 42px, 42px 42px, auto;
}

.login-brand-panel::after {
  content: "";
  position: absolute;
  width: 280px;
  height: 280px;
  right: -125px;
  bottom: 105px;
  border: 55px solid rgba(66, 188, 145, 0.12);
  border-radius: 50%;
  pointer-events: none;
}

.brand-mark {
  position: relative;
  width: 62px;
  height: 48px;
  margin-bottom: 46px;
}

.brand-mark span {
  position: absolute;
  top: 0;
  width: 18px;
  height: 52px;
  border-radius: 6px;
  transform-origin: top center;
}

.brand-mark-left {
  left: 12px;
  background: var(--mint);
  transform: rotate(-34deg);
}

.brand-mark-right {
  right: 12px;
  background: #d6fff0;
  transform: rotate(34deg);
}

.brand-eyebrow,
.welcome-label {
  margin: 0 0 18px;
  color: var(--mint);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 3px;
}

.login-brand-panel h1 {
  margin: 0;
  font-size: 42px;
  line-height: 1.38;
  letter-spacing: 1px;
  font-weight: 700;
}

.brand-description {
  max-width: 390px;
  margin: 24px 0 0;
  color: rgba(255, 255, 255, 0.64);
  font-size: 15px;
  line-height: 1.9;
}

.brand-security {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 14px;
}

.security-icon {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border: 1px solid rgba(66, 188, 145, 0.45);
  border-radius: 13px;
  color: var(--mint);
  background: rgba(66, 188, 145, 0.1);
  font-size: 18px;
}

.brand-security strong {
  font-size: 14px;
  font-weight: 500;
}

.brand-security p {
  margin: 5px 0 0;
  color: rgba(255, 255, 255, 0.45);
  font-size: 12px;
}

.login-form-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 64px 70px;
  background: #fff;
}

.login-form-wrap {
  width: 100%;
  max-width: 360px;
}

.mobile-brand {
  display: none;
}

.login-form-wrap h2 {
  margin: 0;
  color: #172b3a;
  font-size: 34px;
  letter-spacing: 1px;
}

.login-tip {
  margin: 13px 0 40px;
  color: #8a98a5;
  font-size: 14px;
}

.field-label {
  display: block;
  margin-bottom: 9px;
  color: #314454;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
}

.form-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 3px 0 28px;
  color: #93a0aa;
  font-size: 12px;
}

.secure-entry i {
  color: var(--mint-dark);
}

.login-submit {
  width: 100%;
  height: 50px;
  border: 0;
  border-radius: 12px;
  background: linear-gradient(105deg, var(--mint-dark), var(--mint));
  box-shadow: 0 12px 24px rgba(37, 164, 120, 0.24);
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 1px;
}

.login-submit:hover,
.login-submit:focus {
  background: linear-gradient(105deg, #1c956b, #38b889);
}

.login-submit i {
  margin-left: 10px;
}

.login-footer {
  margin: 42px 0 0;
  color: #b0bac2;
  text-align: center;
  font-size: 11px;
}

:deep(.el-form-item) {
  margin-bottom: 26px;
}

:deep(.el-input__inner) {
  height: 50px;
  padding-left: 42px;
  border-color: #dfe7eb;
  border-radius: 12px;
  color: #1e3343;
  background: #f8fafb;
  transition: all 0.2s ease;
}

:deep(.el-input__inner:focus) {
  border-color: var(--mint);
  background: #fff;
  box-shadow: 0 0 0 3px rgba(66, 188, 145, 0.1);
}

:deep(.el-input__prefix) {
  left: 13px;
  color: #91a1ad;
  font-size: 16px;
}

:deep(.el-checkbox__input.is-checked .el-checkbox__inner),
:deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  border-color: var(--mint-dark);
  background-color: var(--mint-dark);
}

:deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
  color: #526473;
}

:deep(.el-checkbox__label) {
  padding-left: 7px;
  color: #788894;
  font-size: 12px;
}

@media (max-width: 850px) {
  .login-page {
    padding: 24px;
  }

  .login-shell {
    max-width: 520px;
    min-height: auto;
    display: block;
  }

  .login-brand-panel {
    display: none;
  }

  .login-form-panel {
    display: block;
    padding: 38px 48px 46px;
  }

  .mobile-brand {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 48px;
    color: var(--navy);
    font-size: 18px;
    font-weight: 700;
  }

  .brand-mark.small {
    width: 38px;
    height: 30px;
    margin: 0;
  }

  .brand-mark.small span {
    width: 11px;
    height: 31px;
    border-radius: 3px;
  }

  .brand-mark.small .brand-mark-left {
    left: 7px;
  }

  .brand-mark.small .brand-mark-right {
    right: 7px;
    background: var(--navy);
  }

  .login-form-wrap {
    max-width: none;
  }
}

@media (max-width: 480px) {
  .login-page {
    align-items: stretch;
    padding: 0;
    background: #fff;
  }

  .login-shell {
    width: 100%;
    border-radius: 0;
    box-shadow: none;
  }

  .login-form-panel {
    min-height: 100vh;
    padding: 34px 26px;
    box-sizing: border-box;
  }

  .mobile-brand {
    margin-bottom: 65px;
  }

  .login-form-wrap h2 {
    font-size: 30px;
  }
}
</style>
